export interface Note { pitch:number|null; beats:number; channel:0|1|2; volume:number }
export interface Song { name:string; bpm:number; notes:Note[]; length:number; loop:boolean }
// Newly composed for this project. No quotation/transcription of Frogger's
// licensed songs or their signature phrases.
const LEAD = [72,79,76,81,79,null,74,77,83,79,76,null,74,72,67,null,
  76,81,79,84,83,79,77,null,74,79,76,71,74,72,null,null];
export const PLAY_SONG:Song={
  name:'River Circuit — original',bpm:142,length:16,loop:true,
  notes:[...LEAD.map((pitch,i)=>({pitch,beats:i*0.5,channel:0 as const,volume:9})),
    ...Array.from({length:16},(_,i)=>({pitch:[48,55,53,55][Math.floor(i/4)]!,beats:i,channel:1 as const,volume:8})),
  ],
};
export const START_SONG:Song={name:'First Leap — original',bpm:160,length:2,loop:false,notes:
  [60,67,72,76,79,84].map((pitch,i)=>({pitch,beats:i/3,channel:0,volume:12}))};
